import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Timestealers = React.lazy(async () => ({
    default: (await import('@oc/timestealers/module')).TimestealersModule
}))

export function TimestealersComponent() {
    return <SuspenseWhileLoading LazyComponent={Timestealers} />
}
